import * as React from 'react';

export interface PublicFooterProps {}

export const PublicFooter = (props: PublicFooterProps) => (
  <footer className="tc ph3 ph4-ns pv5 black-50 bg-white">
    <a
      href="mailto:hello@filtru.coffee"
      className="link b f3 f2-ns dim gold lh-solid"
    >
      hello@filtru.coffee
    </a>
    <p className="f6 db b ttu lh-solid">
      © 2016–2019
      <a
        className="link underline-hover black-60"
        href="https://twitter.com/bobek_balinek"
        target="_blank"
      >
        {' '}
        Przemyslaw Bobak
      </a>
    </p>
    <div className="mt4">
      <a
        href="https://getfiltru.com/terms.html"
        title="Terms"
        className="f6 dib ph2 black-60 dim"
      >
        Terms of Use
      </a>
    </div>
  </footer>
);

export default PublicFooter;
